var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.content,
    _vm.classPosition,
    _vm.classTheme,
    ( _obj = {}, _obj[_vm.$style.tall] = _vm.tall, _obj ),
    _vm.classDevice(_vm.$style) ]},[_c('div',{class:_vm.$style.inner},[(_vm.content.title)?_c('div',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_vm._v(" "),(_vm.content.text)?_c('div',{class:_vm.$style.text},[_vm._v(_vm._s(_vm.content.text))]):_vm._e(),_vm._v(" "),(_vm.hasButton)?_c('span',{class:_vm.$style.button},[_vm._v("\n      "+_vm._s(_vm.content.button.text)+"\n      "),_c('component-icon',{class:_vm.$style.buttonIcon,attrs:{"path":_vm.mdiArrowRight,"size":"20"}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }